module.exports = __webpack_public_path__ + "img/anquan2-2.5cc1f15f.jpg";